$(function () {

    $('.boost-post-ajax').on('click', boost_post);
    $('.unboost-post-ajax').on('click', unboost_post);

});

function boost_post(e) {
    e.preventDefault();

    var form = $(this).parents('form');

    $(this).unbind('click')

    $.post("/post/boost",
        {
            '_token': $('input[name="_token"]', form).val(),
            '_post_id': $('input[name="_post_id"]', form).val(),
        },
        function (data) {
            if (data.success == true) {
                $(this).removeClass('boost-post-ajax')
                    .addClass('unboost-post-ajax')
                    .unbind('click')
                    .bind('click', unboost_post)
                    .attr('data-original-title', $(this).attr('data-original-title').replace('Like this post<br/>', '') + 'You');

                $('.boost-icon', form).removeClass('glyphicon-thumbs-up')
                    .addClass('glyphicon-thumbs-down')

                $('.boost-count-post', form).text(parseInt($('.boost-count-post', form).text()) + 1);

                systemalert(data.message, 'success');
            } else {
                systemalert(data.message, 'warning');
            }
        }.bind(this),
        'json'
    )
        .fail(function () {
            $(this).bind('click', boost_goal);
            systemalert('There was an system error, please notify an admin!', 'danger');
        })
}

function unboost_post(e) {
    e.preventDefault();

    var form = $(this).parents('form');

    $(this).unbind('click')

    $.post("/post/unboost",
        {
            '_token': $('input[name="_token"]', form).val(),
            '_post_id': $('input[name="_post_id"]', form).val(),
        },
        function (data) {
            if (data.success == true) {
                $(this).removeClass('unboost-post-ajax')
                    .addClass('boost-post-ajax')
                    .unbind('click')
                    .bind('click', boost_post)
                    .attr('data-original-title', 'Like this post<br/>');

                $('.boost-icon', form).removeClass('glyphicon-thumbs-down')
                    .addClass('glyphicon-thumbs-up')

                $('.boost-post', form).text(parseInt($('.boost-count-post', form).text()) - 1);

                systemalert(data.message, 'success');
            } else {
                systemalert(data.message, 'warning');
            }

        }.bind(this),
        'json'
    )
        .fail(function () {
            $(this).bind('click', unboost_goal);
            systemalert('There was an system error, please notify an admin!', 'danger');
        })
}
